<template>
	<div class="app">
		<jycheader :navIndex = "0"></jycheader>
		<div class="pay-success-box">
			<div class="pay-success-img">
				<img src="../../assets/image/img/pay_success.png" alt="">
			</div>
			<div class="pay-success-text">支付完成</div>
			<div class="pay-success-tips">
				您可以在个人中心查看<span @click="orderInfo">订单信息</span>
			</div>
			<div class="buy-goods" @click="buyGoods">继续购物</div>
		</div>
		<jycfooter></jycfooter>
	</div>
</template>

<script>
	import jycheader from "../header.vue"
	import jycfooter from "../bottom.vue"
	export default{
		data(){
			return{
				
			}
		},
		components:{
			jycheader,
			jycfooter
		},
		methods:{
			buyGoods(){//继续购物
				this.$router.push({
					path:'/'
				})
			},
			orderInfo(){
                //点击跳转查看订单
				// localStorage.setItem('personal',0)
                let a = localStorage.getItem( 'personal' )
                if (a == 0) {
                    this.$router.push({
                        path:'/order'
                    })
                } else {
                    this.$router.push(
                    {
                        path: '/order',
                        query:
                        {
                            index: 0,
                            personal: 8
                        }
                    } )
                }
				
			}
		}
	}
</script>

<style scoped="scoped">
	.buy-goods{
		width: 5.9375rem;
		height: 1.625rem;
		background-color: #37A115;
		border-radius: 5px;
		color: #FFFFFF;
		font-size: 12px;
		text-align: center;
		line-height: 1.625rem;
		cursor: pointer;
		margin: 1.25rem auto 0 auto;
	}
	.pay-success-tips span{
		color: #37A115;
		cursor: pointer;
	}
	.pay-success-tips{
		margin-top: 0.625rem;
		color: #999999;
		font-size: 16px;
		text-align: center;
	}
	.pay-success-text{
		color: #333333;
		font-size: 24px;
		text-align: center;
		margin-top: 1.875rem;
	}
	.pay-success-img,.pay-success-img img{
		width: 9.375rem;
		height: 9.375rem;
	}
	.pay-success-img{
		margin: auto;
	}
	.pay-success-box{
		width: 100%;
		height: auto;
		background-color: #F2F2F2;
		padding-top: 9.375rem;
		padding-bottom: 6.25rem;
	}
</style>
